// extracted by mini-css-extract-plugin
export var compactFilters = "_k2-4";
export var detailImage = "_k2-1";
export var dropdownContainer = "_k2-2";
export var imageContainer = "_k2-0";
export var selectedCard = "_k2-3";